import styled from 'styled-components';

export const JobAdDescriptionWrapper = styled.div`
  margin-top: 20px;
  margin-bottom: 6px;
`;

export const InfoElement = styled.div`
  display: flex;
  margin-bottom: 14px;
  & > div:first-child {
    margin-right: 8px;
  }

  & > div:last-child {
    max-width: 262px;
    word-break: break-word;
  }
`;
